module.exports = __webpack_public_path__ + "img/sr.36486591.svg";